import { useApiClient } from '../context/AppContext'
import IResourceLoader from '../types/IResourceLoader'
import useCallbackRef from './useCallbackRef'
import useResourceLoader from './useResourceLoader'
import {
  ILoadIncidentSearch,
  IIncidentsData,
  FetchIncidents
} from '../types'
import reportsApi from '../api/incidentsApi'

const useIncidentSearch = (): [
  IResourceLoader<IIncidentsData>,
  ILoadIncidentSearch
] => {
  const apiClient = useApiClient()

  const resource = useResourceLoader<IIncidentsData>(
    'Unable to search incidents'
  )

  const loader = useCallbackRef<FetchIncidents>(
    async (
      SearchType: string,
      searchString: string,
      page: number
    ): Promise<IIncidentsData> => {
      return resource.load(async () =>
        reportsApi.GetIncidents(apiClient, SearchType, searchString, page) as Promise<IIncidentsData>
      )
    }
  )

  return [resource, loader]
}

export default useIncidentSearch
